<template>
  <section class="practice">
    <vue-snotify></vue-snotify>
    <div class="row">
      <aside class="col-md-3 col-sm-12 cus-sidebar">
        <practiceSidebar />
      </aside>
      <div v-if="isLoading" class="loader">
        <div class="wave-container">
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
        </div>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" id="content" class="content col-md-9 col-sm-12">
        <form
          class="form-horizontal fv-form fv-form-bootstrap"
          @submit.prevent="saveUser"
          method="post"
          enctype="multipart/form-data"
        >
          <div class="material-box bg-white row">
            <div class="col-md-12 top-title" style="padding: 0 15px">
              <h3>Renew Memebership</h3>
            </div>
            <div
              class="col-md-12 panel"
              style="padding: 10px 0"
              v-if="BillingInfo.MembershipID == 1 && UPmembershipID == 0"
            >
              <!-- <div class="col-md-12 panel"> -->
              <div class="text-center">
                <b>select your choice of Membership</b>
                <p class="mx-1" style="color: red">
                  Your Trial Membership Fee ($
                  <span v-if="BillingInfo.MembershipServiceID == 9">55</span>
                  <span v-else>95</span>) will be deducted from the cost of your
                  Membership.
                </p>
                <button
                  class="btn btn-primary btn-lg"
                  name="upgrade"
                  @click="upgradePlan(2)"
                >
                  Platinum
                </button>
                <!-- @click="upgradePlan(4)" -->
              </div>
            </div>
            <div
              class="col-md-12 panel"
              style="padding: 10px 0"
              v-else-if="
                BillingInfo.MembershipID == 4 &&
                dateCompare(BillingInfo.MembershipDate)
              "
            >
              <div class="text-center">
                <b>select your choice of Membership</b>
                <!---  <p style="color:red">Your Trial Membership Fee ($<cfif getMembershipsInfo.MembershipServiceID eq 9>55<cfelse>95</cfif>) will be deducted from the cost of your Membership.</p>--->
                <button
                  class="btn btn-primary mx-1 btn-sm"
                  @click="upgradePlan(3)"
                  name="gts50Active"
                  value="1"
                >
                  GTS 100$
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  @click="upgradePlan(4)"
                  name="gts50Active"
                  value="2"
                >
                  Platinum
                </button>
              </div>
            </div>
            <div v-else>
              <div
                class="col-md-12 panel"
                v-if="BillingInfo.MembershipID == 2 && UPmembershipID == 0"
              >
                <div class="">
                  <div class="section text-center panel">
                    <p><b>Upgrade to full Membership</b></p>
                    <!-- <button class="btn btn-primary btn-lg" type="submit" name="upgrade" value="3">Gold </button> -->
                    <button
                      class="btn btn-primary btn-lg"
                      @click="upgradePlan(4)"
                    >
                      Platinum
                    </button>
                  </div>
                </div>
              </div>

              <!-- <template v-if="std_mustUpgrade == 0"> -->
              <template>
                <!-- begin col-6 -->
                <div class="table-responsive">
                  <div class="col-md-12">
                    <h3>{{ BillingInfo.Membership }} Membership</h3>
                    <table class="table table-cart panel membrShip">
                      <thead>
                        <tr>
                          <th>Products</th>
                          <th>&nbsp;</th>
                          <th width="100" class="text-center">Price</th>
                          <th width="100" class="text-center">Quantity</th>
                          <th width="100" class="text-center">
                            Total {{ BillingInfo.Membership }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="2" class="productCell">
                            <b>{{ membershipData.ServiceName }}</b>
                            <p class="productDescription">
                              {{ membershipData.Description }}
                            </p>
                            <span class="subscriptionPlan"
                              >{{
                                formattedCost
                                  ? "$" + formattedCost + "/month"
                                  : ""
                              }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="price">${{ formattedCost }}</span>
                          </td>
                          <td class="text-center">
                            <span class="quantity">{{
                              membershipData.quantity
                            }}</span>
                          </td>
                          <td class="text-right priceCell price">
                            ${{ formattedCost }}
                          </td>
                        </tr>
                        <tr class="subtotal">
                          <td class="leftAlign" colspan="4">
                            <span class="totalPrice">Subtotal</span>
                          </td>
                          <td class="text-right priceCell price">
                            <span class="priceBold" id="total2"
                              >${{ formattedCost }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="section-container section-with-top-border p-b-10">
                    <div class="row">
                      <!-- <div class="col-md-6 panel panel-primary">
                                                <div class="panel-heading bg-drk-blue text-white p-3"><b>Billing
                                                        Information</b>
                                                </div>
                                                <div>
                                                    <label for="u_FirstName">First Name</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend is-text>
                                                            <i class="fa fa-user"></i>
                                                        </b-input-group-prepend>
                                                        <b-form-input type="text" id="u_FirstName" name="u_FirstName"
                                                            autocomplete="u_FirstName" placeholder="First Name"
                                                            v-model="BillingInfo.u_FirstName"
                                                            :state="$v.BillingInfo.u_FirstName.$dirty ? !$v.BillingInfo.u_FirstName.$error : null"
                                                            aria-describedby="input-1-live-feedback"
                                                            label="First Name"></b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">
                                                            This is a required field.
                                                        </b-form-invalid-feedback>
                                                    </b-input-group>
                                                </div>
                                                <div>
                                                    <label for="u_LastName">Last Name:</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend is-text>
                                                            <i class="fa fa-user"></i>
                                                        </b-input-group-prepend>
                                                        <b-form-input type="text" id="u_LastName" name="u_LastName"
                                                            autocomplete="u_LastName" placeholder="Last Name"
                                                            v-model="BillingInfo.u_LastName"
                                                            :state="$v.BillingInfo.u_LastName.$dirty ? !$v.BillingInfo.u_LastName.$error : null"
                                                            aria-describedby="input-1-live-feedback"
                                                            label="Last Name"></b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">
                                                            This is a required field.
                                                        </b-form-invalid-feedback>
                                                    </b-input-group>
                                                </div>
                                                <div>
                                                    <label for="PracticeName">Practice Name:</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend is-text>
                                                            <i class="fa fa-user"></i>
                                                        </b-input-group-prepend>
                                                        <b-form-input type="text" id="PracticeName" name="PracticeName"
                                                            autocomplete="PracticeName" placeholder="First Name"
                                                            v-model="BillingInfo.PracticeName"
                                                            :state="$v.BillingInfo.PracticeName.$dirty ? !$v.BillingInfo.PracticeName.$error : null"
                                                            aria-describedby="input-1-live-feedback"
                                                            label="First Name"></b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">
                                                            This is a required field.
                                                        </b-form-invalid-feedback>
                                                    </b-input-group>
                                                </div>
                                                <div>
                                                    <label for="Address1">Address</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend is-text>
                                                            <i class="fa fa-globe"></i>
                                                        </b-input-group-prepend>
                                                        <b-form-input type="text" v-model="BillingInfo.Address1"
                                                            id="Address1"
                                                            :state="$v.BillingInfo.Address1.$dirty ? !$v.BillingInfo.Address1.$error : null"
                                                            name="Address1" autocomplete="Address1"></b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">
                                                            This is a required field.
                                                        </b-form-invalid-feedback>
                                                    </b-input-group>
                                                </div>
                                                <div> -->
                      <div
                        class="col-md-6 panel panel-primary"
                        style="box-shadow: none"
                      >
                        <div class="panel-heading bg-drk-blue text-white p-3">
                          <b>Billing Information</b>
                        </div>
                        <div
                          class="panel-body"
                          style="border: 1px solid #dddddd !important"
                        >
                          <div class="m-b-10">
                            <label for="FirstName">First Name</label>
                            <b-input-group>
                              <b-input-group-prepend is-text>
                                <i class="fa fa-user"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                type="text"
                                id="FirstName"
                                name="FirstName"
                                autocomplete="FirstName"
                                placeholder="First Name"
                                v-model="BillingInfo.u_FirstName"
                                :state="
                                  $v.BillingInfo.u_FirstName.$dirty
                                    ? !$v.BillingInfo.u_FirstName.$error
                                    : null
                                "
                                aria-describedby="input-1-live-feedback"
                                label="First Name"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                id="input-1-live-feedback"
                              >
                                This is a required field.
                              </b-form-invalid-feedback>
                            </b-input-group>
                          </div>
                          <div class="m-b-10">
                            <label for="LastName">Last Name:</label>
                            <b-input-group>
                              <b-input-group-prepend is-text>
                                <i class="fa fa-user"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                type="text"
                                id="LastName"
                                name="LastName"
                                autocomplete="LastName"
                                placeholder="Last Name"
                                v-model="BillingInfo.u_LastName"
                                :state="
                                  $v.BillingInfo.u_LastName.$dirty
                                    ? !$v.BillingInfo.u_LastName.$error
                                    : null
                                "
                                aria-describedby="input-1-live-feedback"
                                label="Last Name"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                id="input-1-live-feedback"
                              >
                                This is a required field.
                              </b-form-invalid-feedback>
                            </b-input-group>
                          </div>
                          <div class="m-b-10">
                            <label for="PracticeName">Practice Name:</label>
                            <b-input-group>
                              <b-input-group-prepend is-text>
                                <i class="fa fa-user"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                type="text"
                                id="PracticeName"
                                name="PracticeName"
                                autocomplete="PracticeName"
                                placeholder="First Name"
                                v-model="BillingInfo.PracticeName"
                                :state="
                                  $v.BillingInfo.PracticeName.$dirty
                                    ? !$v.BillingInfo.PracticeName.$error
                                    : null
                                "
                                aria-describedby="input-1-live-feedback"
                                label="First Name"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                id="input-1-live-feedback"
                              >
                                This is a required field.
                              </b-form-invalid-feedback>
                            </b-input-group>
                          </div>
                          <div class="m-b-10">
                            <label for="Address1">Address</label>
                            <b-input-group>
                              <b-input-group-prepend is-text>
                                <i class="fa fa-globe"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                type="text"
                                v-model="BillingInfo.Address1"
                                id="Address1"
                                :state="
                                  $v.BillingInfo.Address1.$dirty
                                    ? !$v.BillingInfo.Address1.$error
                                    : null
                                "
                                name="Address1"
                                autocomplete="Address1"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                id="input-1-live-feedback"
                              >
                                This is a required field.
                              </b-form-invalid-feedback>
                            </b-input-group>
                          </div>
                          <div class="m-b-10">
                            <b-input-group>
                              <b-input-group-prepend is-text>
                                <i class="fa fa-globe"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                type="text"
                                id="Address2"
                                name="Address2"
                                autocomplete="Address2"
                                v-model="BillingInfo.Address2"
                              ></b-form-input>
                            </b-input-group>
                          </div>
                        </div>
                        <div>
                          <label for="City">City:</label>
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              <i class="fa fa-globe"></i>
                            </b-input-group-prepend>
                            <b-form-input
                              type="text"
                              id="City"
                              name="City"
                              autocomplete="City"
                              :state="
                                $v.BillingInfo.City.$dirty
                                  ? !$v.BillingInfo.City.$error
                                  : null
                              "
                              v-model="BillingInfo.City"
                            ></b-form-input>
                            <b-form-invalid-feedback id="input-1-live-feedback">
                              This is a required field.
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </div>
                        <div>
                          <label for="StateID">State:</label>
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              <i class="fa fa-globe"></i>
                            </b-input-group-prepend>
                            <b-form-select
                              id="StateID"
                              v-model="BillingInfo.StateID"
                              :state="
                                $v.BillingInfo.StateID.$dirty
                                  ? !$v.BillingInfo.StateID.$error
                                  : null
                              "
                              :options="StateOptions"
                              value-field="StateID"
                              text-field="Name"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback id="input-1-live-feedback">
                              This is a required field.
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </div>
                        <div>
                          <label for="ZipCode">Zip:</label>
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              <i class="fa fa-globe"></i>
                            </b-input-group-prepend>
                            <b-form-input
                              type="text"
                              id="ZipCode"
                              name="ZipCode"
                              :state="
                                $v.BillingInfo.ZipCode.$dirty
                                  ? !$v.BillingInfo.ZipCode.$error
                                  : null
                              "
                              autocomplete="ZipCode"
                              v-model="BillingInfo.ZipCode"
                            ></b-form-input>
                            <b-form-invalid-feedback id="input-1-live-feedback">
                              This is a required field.
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </div>
                        <div>
                          <label for="Phone">Phone:</label>
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              <i class="fa fa-globe"></i>
                            </b-input-group-prepend>
                            <b-form-input
                              type="text"
                              id="Phone"
                              :state="
                                $v.BillingInfo.Phone.$dirty
                                  ? !$v.BillingInfo.Phone.$error
                                  : null
                              "
                              name="Phone"
                              autocomplete="Phone"
                              v-model="BillingInfo.Phone"
                            ></b-form-input>
                            <b-form-invalid-feedback id="input-1-live-feedback">
                              This is a required field.
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div
                          class="panel panel-primary"
                          style="box-shadow: none"
                        >
                          <div class="panel-heading bg-drk-blue text-white p-3">
                            <b>Order Summary</b>
                          </div>
                          <div
                            class="panel-body"
                            style="border: 1px solid #dddddd !important"
                          >
                            <div class="row">
                              <div class="col-xs-7"><span>Subtotal</span></div>
                              <div class="col-xs-5 text-right">
                                <span id="total3">${{ formattedCost }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="panel-footer">
                            <div class="row">
                              <div class="col-xs-7"><b>Total Due</b></div>
                              <div class="col-xs-5 text-right">
                                <b
                                  ><span id="total4"
                                    >${{ formattedCost }}</span
                                  ></b
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="col-md-12 mt-3">
              <div class="panel panel-primary" style="box-shadow: none">
                <div class="panel-heading bg-drk-blue p-3 bold text-white">
                  <b>Payment</b>
                </div>
                <input
                  id="creditCardType"
                  name="paymentType"
                  type="hidden"
                  value="creditcard"
                />
                <div
                  class="panel-body"
                  style="border: 1px solid #dddddd !important"
                >
                  <img
                    src="../../../assets/images/credit-cards.png"
                    height="30"
                    class="paymentIcon"
                  />
                  <span class="smallHeader"> Credit card</span>
                  <div class="row">
                    <div class="col-lg-3 col-md-6 form-group">
                      <label for="CardNumber">Credit Card Number:</label>
                      <b-input-group>
                        <b-form-input
                          type="text"
                          id="CardNumber"
                          name="CardNumber"
                          :state="
                            $v.BillingInfo.CardNumber.$dirty
                              ? !$v.BillingInfo.CardNumber.$error
                              : null
                          "
                          autocomplete="CardNumber"
                          v-model="BillingInfo.CardNumber"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>

                    <div class="col-lg-3 col-md-6 form-group">
                      <label for="Fax">Expiration Month:</label>
                      <b-input-group>
                        <b-form-select
                          id="CardMonth"
                          :state="
                            $v.BillingInfo.CardMonth.$dirty
                              ? !$v.BillingInfo.CardMonth.$error
                              : null
                          "
                          v-model="BillingInfo.CardMonth"
                          :options="month"
                          value-field="m"
                          text-field="m"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="col-lg-3 col-md-6 form-group">
                      <label for="Fax">Expiration Year:</label>
                      <b-input-group>
                        <b-form-select
                          id="CardYear"
                          v-model="BillingInfo.CardYear"
                          :options="year"
                          :state="
                            $v.BillingInfo.CardYear.$dirty
                              ? !$v.BillingInfo.CardYear.$error
                              : null
                          "
                          value-field=""
                          text-field=""
                        >
                        </b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="col-lg-3 col-md-6 form-group">
                      <label for="CardCode">CVV Code:</label>
                      <b-input-group>
                        <b-form-input
                          type="text"
                          id="CardCode"
                          name="CardCode"
                          :state="
                            $v.BillingInfo.CardCode.$dirty
                              ? !$v.BillingInfo.CardCode.$error
                              : null
                          "
                          autocomplete="CardCode"
                          v-model="BillingInfo.CardCode"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>

                    <div class="col-md-12">
                      <button
                        type="submit"
                        class="btn btn-primary btn-blue"
                        name="placeOrderAuthorize"
                        id="placeOrderAuthorize"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>


<script>
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "view_user",
  components: {
    practiceSidebar,
  },
  mixins: [validationMixin],
  data() {
    return {
      isLoading: false,
      pField: "password",
      membershipData: {},
      loginUser: {},
      std_mustUpgrade: 0,
      emailErr: "",
      imagePreviewUrl: "",
      UPmembershipID: 0,
      StateOptions: [],
      pages: [
        "SeminarPackingItems",
        "Members",
        "Seminars",
        "Webinar",
        "EmailMarketing",
        "Referrals",
        "Modules",
        "Documents",
        "Videos",
        "Webcontent",
      ],
      month: [
        { m: 1 },
        { m: 2 },
        { m: 3 },
        { m: 4 },
        { m: 5 },
        { m: 6 },
        { m: 7 },
        { m: 8 },
        { m: 9 },
        { m: 10 },
        { m: 11 },
        { m: 12 },
      ],
      year: [],
      allowedPages: [],
      BillingInfo: {
        PracticeName: "",
        u_FirstName: "",
        CardNumber: "",
        CardMonth: 1,
        CardYear: "",
        u_LastName: "",
        CardCode: "",
        StateID: "",
        Phone: "",
        City: "",
        Address1: "",
        Address2: "",
        ZipCode: "",
      },
      StatusOptions: [{ item: "DC" }, { item: "CA" }],
      PrefixOptions: [
        { item: "Dr." },
        { item: "Mr." },
        { item: "Mrs." },
        { item: "Ms." },
      ],
    };
  },
  validations: {
    BillingInfo: {
      u_FirstName: {
        required,
      },
      PracticeName: {
        required,
      },
      u_LastName: {
        required,
      },
      CardCode: {
        required,
      },
      CardNumber: {
        required,
      },
      CardMonth: {
        required,
      },
      CardYear: {
        required,
      },
      StateID: {
        required,
      },
      Phone: {
        required,
      },
      City: {
        required,
      },
      Address1: {
        required,
      },
      ZipCode: {
        required,
      },
    },
  },
  methods: {
    dateCompare(date) {
      let memberDate = new Date(date);
      let today = new Date();
      return memberDate <= today;
    },
    yearGenerate() {
      let cYear = parseInt(moment().format("Y"));
      let yearArr = [];
      for (let i = 0; i < 10; i++) {
        yearArr.push(cYear + i);
      }
      this.year = yearArr;
    },
    getStates() {
      userAPI.getStates(
        (res) => {
          this.StateOptions = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getUserinfo() {
      this.isLoading = true;
      userAPI.getUserinfo(
        { UserID: this.loginUser.userID },
        (res) => {
          const graduationDate = new Date(res.data.data.GraduationDate);
          const currentDate = new Date();
          this.std_mustUpgrade =
            currentDate.getMonth() +
              1 -
              (graduationDate.getMonth() + 1) +
              12 * (currentDate.getFullYear() - graduationDate.getFullYear()) >
            5
              ? 1
              : 0;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },

    getMembershipsInfoByID() {
      userAPI.getMembershipsInfoByID(
        { UserID: this.loginUser.userID },
        (res) => {
          this.BillingInfo = res.data.data;
          console.log(res.data.data);
          this.membershipPlan(
            this.BillingInfo.Membership,
            this.BillingInfo.MembershipServiceID
          );
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getSpecailLimitedAmount(upgrade, isAfterTrail = 0) {
      userAPI.getSpecailLimitedAmount(
        { upgrade, isAfterTrail },
        (res) => {
          this.membershipData = res.data.data;
          this.membershipData.dues = "";
          this.membershipData.quantity = 1;
          if (this.UPmembershipID === 3) {
            this.membershipData.plan = "Platinum";
          }
        },
        (err) => {}
      );
    },
    upgradePlan(MembershipID) {
      console.log("MembershipID :", MembershipID);
      this.UPmembershipID = MembershipID;
      this.membershipPlan();
      // this.getMonthlyAmount({ MembershipID:MembershipID });
    },
    getMonthlyAmount({ MembershipID = 3, serviceid, isAfterTrial = 1 }) {
      userAPI.getMonthlyAmount(
        { MembershipID: 3, serviceid, isAfterTrial },
        (res) => {
          this.membershipData = res.data.data;
          this.membershipData.dues = "";
          this.membershipData.quantity = 1;
          if (this.UPmembershipID === 3) {
            console.log("this.UPmembershipID :", this.UPmembershipID);
            this.membershipData.plan = "Platinum";
          }
        },
        (err) => {}
      );
    },
    membershipPlan() {
      console.log(this.BillingInfo.Membership);
      switch (this.BillingInfo.Membership) {
        case "Trial":
          if (this.UPmembershipID > 0) {
            if (this.BillingInfo.MembershipServiceID === 9) {
              this.getSpecailLimitedAmount(this.UPmembershipID, 1);
            } else {
              this.getMonthlyAmount({
                MembershipID: this.UPmembershipID,
                isAfterTrail: 1,
              });
            }
          }
          break;
        case "Student":
          this.getMonthlyAmount({
            MembershipID: this.UPmembershipID,
            serviceid: 2,
          });
          if (this.UPmembershipID > 0) {
            this.getMonthlyAmount({
              MembershipID: this.UPmembershipID,
              serviceid: this.UPmembershipID,
            });
          } else if (this.dateCompare(this.BillingInfo.MembershipDate) > 5) {
            this.std_mustupgrade = 1;
          }
          break;
        case "Gold":
          this.getMonthlyAmount({
            MembershipID: 3,
            serviceid: this.UPmembershipID,
          });
          break;
        case "Platinum":
          this.getMonthlyAmount({
            MembershipID: 4,
            serviceid: this.UPmembershipID,
          });
          break;
        default:
          this.getMonthlyAmount({
            MembershipID: this.UPmembershipID,
            serviceid: 4,
          });
          break;
      }
    },
    limitedAdmin(event) {
      this.BillingInfo.Admin = event.target.checked ? 1 : 0;
    },
    allowPageFn() {
      this.BillingInfo.allowedPages = this.allowedPages.join(",");
    },
    handleFileUpload(event) {
      const file = event.target.files[0];

      // Store the selected file
      this.BillingInfo.Image = file;

      // Read the file and generate a preview URL
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreviewUrl = reader.result;
      };
      reader.readAsDataURL(file);
    },
    showPass() {
      this.pField = this.pField == "password" ? "text" : "password";
    },
    removeImage() {
      this.imagePreviewUrl = "";
      this.BillingInfo.Image = null;
      this.$refs.fileInput.value = "";
    },
    saveUser() {
      this.$v.BillingInfo.$touch();

      if (this.$v.BillingInfo.$anyError) {
        return;
      }
      console.log({ ...this.BillingInfo });
      userAPI.UpdatePracticeAccount(
        { ...this.BillingInfo, UserID: this.loginUser.userID },
        (res) => {
          this.$showNotification(
            { message: "Memebership Updated Successfully" },
            "success"
          );
        },
        (err) => {
          if (err.response.status == 410) {
            this.emailErr = err.response.data.message.Email[0];
          }
        }
      );
    },
  },
  computed: {
    formattedCost() {
      return Number(this.membershipData.Cost).toFixed(2);
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;

    if (user.Status == "DC" || user.Status == "CA") {
      this.$router.push({ name: "user_dashboard" });
    }
    this.getUserinfo();
    this.yearGenerate();
    this.getMembershipsInfoByID();
    this.getStates();
    // this.membershipPlan()
  },
};
</script>